import { connect } from 'react-redux'
import Score from '../pages/score/Score'
import * as consts from '../store/constant'
import favInput from '../assets/json/user-favorites/input.json'
//import cxScoreTrend from '../assets/json/score_details/group/group1.json'

const mapStateToProps = state => {
    return {
        selectedSubRegion: state.SubRegionReducer ? state.SubRegionReducer.data : null,
        selectedStrategicAccount : state.StrategicActReducer ? state.StrategicActReducer.data : null,
        cxScoreDetails: state.KPIReducer ? state.KPIReducer.cxScoreDetails : null,
        breadCrumb: state.KPIReducer ? state.KPIReducer.breadCrumb : null,
        selectedKPI: state.KPIReducer ? state.KPIReducer.selectedKPI : null,
        selectedProductDivision: state.ProductDivisionReducer ? state.ProductDivisionReducer.data : null,
        selectedSBS: state.SBSReducer ? state.SBSReducer.data : null,
        selectedCustomer: state.CustomerReducer ? state.CustomerReducer.data : null,
        sasParent: state.SASReducer ? state.SASReducer.data : null,
        
        favInput: favInput,
        //cxScoreTrend: cxScoreTrend,
        favorites: state.FavoriteReducer ? state.FavoriteReducer.data : null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setKPI: (data) => dispatch({
            type: consts.SET_KPI,
            data: data
        }),
        setBannerType: (data) => dispatch({
            type: consts.SET_BANNER_TYPE,
            data: data
        }),
        setBreadCrumb: (data) => dispatch({
            type: consts.SET_BREAD_CRUMB,
            data: data
        }),
        setFavorite: (data) => dispatch({
            type: consts.SET_FAVORITE,
            data: data
        }),
        setSASParent: (data) => dispatch({
            type: consts.SET_SAS_PARENT,
            data: data
        })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Score)
